import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderSummary', {
  title: 'Resumen de tu pedido'
});
